<template>
  <div>
    <b-modal
      id="modal-instrument-warehouse2"
      title="Поделиться Инструменты"
      cancel-variant="outline-secondary"
      :ok-title="$t('save')"
      ok-variant="success"
      :cancel-title="$t('cancel')"
      centered
      size="md"
      no-close-on-backdrop
    >
      <b-form>
        <b-form-group
          :label="$t('reference.categoriya')"
        >
          <b-form-input
            v-model="instrument.category"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('reference.name')"
        >
          <b-form-input
            v-model="instrument.title"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('model')"
        >
          <b-form-input
            v-model="instrument.model"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('amount')"
        >
          <b-form-input
            v-model="instrument.count"
          />
        </b-form-group>

        <b-form-group
          :label="$t('where2')"
        >
          <v-select
            v-model="instrument.where"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
          />
        </b-form-group>

        <b-form-group
          :label="$t('to_whom')"
        >
          <v-select
            v-model="instrument.whom"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="option"
          />
        </b-form-group>

        <b-form-group
          :label="$t('courses.file')"
        >
          <b-form-file
            v-model="instrument.file"
            :placeholder="$t('choose_file_or_drop')"
          />

          <div class="d-flex align-items-center justify-content-between mt-1">
            <b-link
              class="text-decoration"
            >
              <span v-if="!instrument.file">
                *Названия файла
              </span>

              <span v-if="instrument.file">
                {{ instrument.file.name }}
              </span>
            </b-link>

            <b-button
              class="p-50"
              size="sm"
              variant="danger"
              @click="instrument.file = null"
            >
              <feather-icon
                icon="TrashIcon"
              />
            </b-button>
          </div>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormFile,
  BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    BFormFile,
    BLink,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      instrument: {
        category: '',
        title: '',
        model: '',
        count: null,
        whom: null,
        file: null,
        where: null,
      },
      option: [],
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.text-decoration {
  text-decoration: underline;
}
</style>
